import React from 'react';
import PropTypes from 'prop-types';
import Project from '../templates/Project';
import Content from '../components/Content';
import WorkDone from '../components/WorkDone';
import projects from '../project_data';
import mastImage from '../images/projects/eds-job-map/mast.png';
import SkillCreator from '../components/SkillCreator/SkillCreator';
import ProjectLinks from '../components/ProjectLinks/projectLinks';
import FeatureCreator from '../components/FeatureCreator/FeatureCreator';

const EDSJobMap = ({ path }) => (
  <Project title="EDS Job Map" image={mastImage} pathname={path}>
    <Content header="About">
      <p>
        Officers browsing available extra-duty jobs previously had to scan a flat 
        list with no sense of where a job actually was relative to them.
      </p>
      <p>
        I built a bidirectional map-table interface, clicking anywhere on the 
        map draws a search radius centered on that point, instantly filtering 
        both the pin set and the table to jobs within range. 
      </p>
      <p>
        Selecting a pin highlights its matching row, and selecting a row flies 
        the map to that pin, keeping both views in sync as officers narrow 
        down jobs geographically.
      </p>
      <div className="project-page-work">
        <h2 className="project-page-work--title">Accomplishments</h2>
        <WorkDone projectData={projects.get('ejm')} />
      </div>
      <div className="project-page-tech">
        <SkillCreator projectData={projects.get('ejm')} />
      </div>
      <div className="project-page-btns project-page-btns--launch-date">
        <ProjectLinks projectData={projects.get('ejm')} />
      </div>
      <FeatureCreator projectData={projects.get('ejm')} />
    </Content>
  </Project>
);

EDSJobMap.propTypes = {
  path: PropTypes.string.isRequired,
};

export default EDSJobMap;
